import React from 'react';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  IMarketplaceFilterLocationFilter,
  IMarketplaceProperty, sortOrderOptions, sortOrderOptionsMap, SortOrderType,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import {
  useStyles,
} from './styles';

interface LocationSubGroupLocationGroupProps {
  item: IMarketplaceFilterLocationFilter,
  lang: string,
  locationOptions: IDevelopmentSpecificationPropChange<IMarketplaceProperty>[]
  onChange: (item: IMarketplaceFilterLocationFilter) => void,
}

export const LocationSubGroupLocationGroup: React.FC<LocationSubGroupLocationGroupProps> = ({
  item, lang, locationOptions, onChange,
}) => {
  const styles = useStyles();
  return (
    <div className={styles.locationsSubGroupFields}>
      <BoxFormTextField
        label={translations.name}
        name="name"
        defaultValue={item.name?.[lang]}
        onChange={(event) => {
          onChange(updateTranslatedField(item, 'name', lang, event.target.value));
        }}
      />
      <BoxFormAutocomplete
        label={translations.selectContainer}
        name="container"
        defaultValue={{ label: item.property?.translates?.[lang] || item.property?.systemName, value: item.property }}
        onChange={(event: IDevelopmentSpecificationPropChange<IMarketplaceProperty>) => {
          onChange({ ...item, property: event.value });
        }}
        options={locationOptions}
      />
      <BoxFormAutocomplete
        label={translations.containerSortOrder}
        name="containerSortOrder"
        defaultValue={
          item.propertyValuesOrder
            ? {
              label: sortOrderOptionsMap[item.propertyValuesOrder],
              value: item.propertyValuesOrder,
            }
            : undefined
        }
        options={sortOrderOptions}
        onChange={(event: IDevelopmentSpecificationPropChange<SortOrderType>) => {
          onChange({ ...item, propertyValuesOrder: event.value });
        }}
      />
      <BoxFormAutocomplete
        label={translations.selectElement}
        name="element"
        defaultValue={{ label: item.subFilters[0].property?.translates?.[lang] || item.subFilters[0].property?.systemName, value: item.subFilters[0].property }}
        onChange={(event: IDevelopmentSpecificationPropChange<IMarketplaceProperty>) => {
          onChange({
            ...item,
            subFilters: item.subFilters.map((subFilter, index) => (
              index === 0 ? { ...subFilter, property: event.value } : subFilter
            )),
          });
        }}
        options={locationOptions}
      />
      <BoxFormAutocomplete
        label={translations.elementSortOrder}
        name="elementSortOrder"
        defaultValue={
          item.propertyValuesOrder
            ? {
              label: sortOrderOptionsMap[item.propertyValuesOrder],
              value: item.propertyValuesOrder,
            }
            : undefined
        }
        options={sortOrderOptions}
        onChange={(event: IDevelopmentSpecificationPropChange<SortOrderType>) => {
          onChange({ ...item, propertyValuesOrder: event.value });
        }}
      />
    </div>
  );
};
